import { render, staticRenderFns } from "./GoodsSeriesItems.vue?vue&type=template&id=5b3a91de&scoped=true&"
import script from "./GoodsSeriesItems.vue?vue&type=script&lang=js&"
export * from "./GoodsSeriesItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3a91de",
  null
  
)

export default component.exports